import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { Observable } from "rxjs/Observable";

// This is bi-directional shared service we can use this for creating method which can be exposed & used for any child=>Parent or vice versa communication
@Injectable()
export class EventService {
    private events = new BehaviorSubject<boolean>(false);
    private notificationEvents = new BehaviorSubject<boolean>(false);

    constructor() { }

    public showProcessingSpinner() {
        this.events.next(true);
    }

    public hideProcessingSpinner() {
        this.events.next(false);
    }

    public get processingSpinnerStatus(): Observable<boolean> {
        return this.events.asObservable();
    }

    public setTrueNotification() {
        this.notificationEvents.next(true);
    }

    public setFalseNotification() {
        this.notificationEvents.next(false);
    }

    public get getNotificationStatus(): Observable<boolean> {
        return this.notificationEvents.asObservable();
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/services/event.service.ts